export const AttributeValidationSchema = {
  name: {
    required: true,
    pattern: /^\w+$/
  },
  value: {
    required: true,
    pattern: /^\w+$/
  }
};
